import React from 'react'
import { IconButton, Tooltip, Grid } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import MonochromePhotosIcon from '@mui/icons-material/MonochromePhotos'
import useSystemState from '~/features/System/stores/SystemState'
interface ReportingRecordButtonProps {
  readonly canAddReportingRecord: boolean
}

export default function VideoMonitoringButton({
  canAddReportingRecord,
}: ReportingRecordButtonProps) {
  const { translate } = useLang()
  const { windowManager } = useSystemState()

  const handleChange = () => {
    windowManager()['videoMonitoringCards'].open.set(true)
  }
  return (
    <Grid item>
      <Tooltip
        title={translate('See Videomonitoring narrations')}
        placement="right-start"
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton disabled={!canAddReportingRecord} onClick={handleChange}>
            <MonochromePhotosIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  )
}
